<template>
  <div>
    <el-table style="width: 100%;" :data="cartListClone" class="mb-4" show-summary :summary-method="getSummaries" :class="{ [$style.detailTable]: true, [$style.fullWidth]: true }">
      <el-table-column label="項目／售價" min-width="180">
        <template slot-scope="scope">
          <div class="goods-info">
            <h5 v-if="scope.row.alias" class="mb-1">{{ scope.row.serviceTitle }}</h5>
            <span v-if="scope.row.code">{{ `優惠券(${scope.row.code})` }}</span>
            <span v-else>{{ detailTitle(scope.row) }}</span>
          </div>
          <div v-if="scope.row.spec" class="goods-info">
            <span>{{ formattedSpecs(scope.row.spec) }}</span>
            <p>NT$: {{ scope.row.prices[0].price }}</p>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="數量" min-width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.qty" class="d-flex w-100 justify-content-center  align-items-center">
            <el-button
              v-show="scope.row.prices"
              type="info"
              round
              plain
              size="mini"
              icon="el-icon-minus"
              @click="purchaseNumUpdate('minus', scope.row.alias)"
              :disabled="scope.row.qty <= 1"
            ></el-button>
            <span style="margin: 0 10px;">{{ scope.row.qty }}</span>
            <el-button
              v-show="scope.row.prices"
              type="primary"
              round
              plain
              size="mini"
              icon="el-icon-plus"
              @click="purchaseNumUpdate('plus', scope.row.alias)"
              :disabled="scope.row.qty >= scope.row.inventory"
            ></el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column :label="`小計`" min-width="60" prop="prices">
        <template slot-scope="scope">
          <div style="text-align: center;">
            <span v-if="scope.row.alias">{{ scope.row.prices[0].price * scope.row.qty }}</span>
            <span v-else-if="scope.row.type === '%'">{{ `- ${scope.row.difference}` }}</span>
            <span v-else>{{ scope.row.type }} {{ scope.row.price }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column min-width="40">
        <template slot-scope="scope">
          <a v-if="!scope.row.code" href="#" @click="deleteProduct(scope.$index)"><i class="el-icon-delete"></i></a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: {
    priceChange: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cartListClone: [],
      totalEditParams: [],
    }
  },
  computed: {
    ...mapGetters('cart', ['cartList']),
    ...mapState('cart', ['couponInfo', 'cart']),
    totalPrice() {
      let total = 0 // 總價
      this.totalEditParams = [] // 變更後的品項
      // 將商品清單按照商品與變價進行分類
      const goodsData = []
      const priceChangeData = []
      this.cartListClone.forEach((item) => {
        if (!item.code) {
          if (!item.type) item.type = 'goods'
          item.type === 'goods' ? goodsData.push(item) : priceChangeData.push(item)
        }
      })
      // 商品總額
      total = goodsData.reduce((acc, cur) => {
        return acc + cur.prices[0].price * cur.qty
      }, total)
      // 先計算優惠券折抵
      if (Object.keys(this.couponInfo).length) {
        total -= this.couponInfo.type === '%' ? Math.ceil((total * this.couponInfo.discount) / 100) : this.couponInfo.discount
      }
      // 再計算變價項目
      if (priceChangeData.length) {
        priceChangeData.forEach((item) => {
          switch (item.type) {
            case '+':
              total += item.price
              break

            case '-':
              total -= item.price
              break

            case '%':
              const difference = Math.round((total * item.price) / 100)
              item.difference = difference
              total -= difference
              break
          }
        })
      }
      // 變更後的商品清單送回父元件
      this.totalEditParams = [...goodsData, ...priceChangeData]
      this.$emit('total-edit-params', this.totalEditParams)
      // 變價的資料及總價送入store
      this.$store.commit('cart/CHANGE_PRICE', priceChangeData)
      this.$store.commit('cart/UPDATE_TOTALPRICE', total)
      return total
    },
  },
  methods: {
    cloneCartData() {
      this.cartListClone = cloneDeep(this.cartList)
      // 計算優惠券折抵值
      if (Object.keys(this.couponInfo).length) {
        const coupon = cloneDeep(this.couponInfo)
        const productsData = this.cartListClone.filter((item) => !item.hasOwnProperty('type'))
        const total = productsData.reduce((acc, cur) => acc + cur.prices[0].price * cur.qty, 0)
        coupon.difference = coupon.type === '%' ? Math.ceil((total * coupon.discount) / 100) : coupon.discount
        const index = this.cartListClone.findIndex((item) => !item.alias)
        index === -1 ? this.cartListClone.push(coupon) : this.cartListClone.splice(index, 0, coupon)
      }
    },
    // 購買數量變更
    purchaseNumUpdate(type, id) {
      this.$store.commit('cart/UPDATE_PURCHASE_NUM', { type: type, id: id })
      this.cloneCartData()
    },
    deleteProduct(index) {
      this.$store.commit('cart/DELETE_PRODUCT', index)
      this.cloneCartData()
    },
    getSummaries() {
      const sums = ['總計', '', this.totalPrice, '']
      return sums
    },
    detailTitle(item) {
      switch (item.type) {
        case '+':
          return '加價'
        case '-':
          return '減價'
        case '%':
          return '折扣' + item.price + item.type
        case 'coupon':
          return `優惠券(${item.code})`
      }
    },
    formattedSpecs(specs) {
      return specs.map((spec) => `${spec.title}: ${spec.values[0].title}`).join(' | ')
    },
  },
  created() {
    this.cloneCartData()
  },
}
</script>

<style lang="scss" module>

.fullWidth {
  :global {
    .el-table__header {
      width: 100% !important;
    }

    .el-table__empty-block {
      width: 100% !important;
    }

    .el-table__body {
      width: 100% !important;
    }
  }
}

.detailTable {
  &::before {
    height: 0;
    display: none;
  }

  :global {
    .goods-img {
      width: 100%;
    }

    .goods-info {
      p {
        margin: 0;
      }
    }

    .goods-amount {
      max-width: 100px;
    }

    .el-table__row {
      background-color: #ffffff;
    }

    .el-table__header-wrapper {
      th {
        background-color: #e5e7eb;
      }
      tr th .cell {
        display: flex;
        justify-content: center;
      }
      tr th:nth-child(1) .cell {
        justify-content: start;
      }
    }

    .el-table__footer-wrapper {
      tr td {
        background-color: #ffffff !important;
      }
      tr td:nth-child(3) .cell {
        text-align: center;
      }
    }

    th {
      border: none !important;
    }

    .close-icon {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
